import { render, staticRenderFns } from "./Appliances.vue?vue&type=template&id=bc9ae164&scoped=true&"
import script from "./Appliances.vue?vue&type=script&lang=js&"
export * from "./Appliances.vue?vue&type=script&lang=js&"
import style0 from "./Appliances.vue?vue&type=style&index=0&id=bc9ae164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9ae164",
  null
  
)

export default component.exports